export default __webpack_public_path__ + "maps-examples-approximate-location-960-65d73326060abee7d5bf1f1fa035b08f.webp";